import React from "react";
import { Instagram, Facebook, MessageCircle } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img
              src="/logo-vertical.png"
              alt="NoriVet — Clínica Veterinaria"
              className="h-24 w-auto"
            />
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-xs">
              Clínica Veterinaria de pequeños animales en Leganés. Cuidamos de
              tu mascota con el cariño que merece.
            </p>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold text-white text-sm uppercase tracking-wider">
              Información
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  href="#aviso-legal"
                  data-testid="footer-legal-notice"
                  className="hover:text-violet-300 transition-colors"
                >
                  Aviso Legal
                </a>
              </li>
              <li>
                <a
                  href="#privacidad"
                  data-testid="footer-privacy"
                  className="hover:text-violet-300 transition-colors"
                >
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a
                  href="#cookies"
                  data-testid="footer-cookies"
                  className="hover:text-violet-300 transition-colors"
                >
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold text-white text-sm uppercase tracking-wider">
              Síguenos
            </h4>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://www.instagram.com/norivet.leganes/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-11 h-11 rounded-full bg-slate-800 hover:bg-violet-500 flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" strokeWidth={2} />
              </a>

              <a
                href="https://wa.me/34684366280"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
                className="w-11 h-11 rounded-full bg-slate-800 hover:bg-violet-500 flex items-center justify-center transition-colors"
              >
                <MessageCircle className="w-5 h-5" strokeWidth={2} />
              </a>

              {/* <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-11 h-11 rounded-full bg-slate-800 hover:bg-violet-500 flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" strokeWidth={2} />
              </a> */}
            </div>
            <p className="mt-6 text-sm text-slate-400">
              📞{" "}
              <a
                href="tel:684366280"
                className="hover:text-violet-300 transition-colors"
              >
                684 36 62 80
              </a>
            </p>
            <p className="text-sm text-slate-400">
              📍 C. Melilla, 5, Local 3, Leganés
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Norivet. Todos los derechos reservados.</p>
          <p>Hecho con ❤ para los pequeños animales de Leganés.</p>
        </div>
      </div>
    </footer>
  );
};
